import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  PageHeaderElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BlockRenderer } from "@easy-email-pro-core/components";
import { Element } from "slate";

const defaultData: ElementDefinition<PageHeaderElement>["defaultData"] = {
  attributes: {
    "padding-top": "0px",
    "padding-right": "0px",
    "padding-bottom": "0px",
    "padding-left": "0px",
  },
  data: {
    content: [],
    editable: false,
  },
};

export const PageHeader = createBlock<PageHeaderElement>({
  get name() {
    return t("Header");
  },
  void: true,
  defaultData,
  type: BasicType.PAGE_HEADER,
  create: (payload) => {
    const data: PageHeaderElement = {
      type: BasicType.PAGE_HEADER,
      data: {
        ...defaultData.data,
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(data, payload);
  },
  get category() {
    return ElementCategory.PAGE_HEADER;
  },
  render(params) {
    const wrapNode = {
      ...params.node,
      type: BasicType.WRAPPER,
      attributes: {
        ...params.node.attributes,
      },
    };
    return (
      <BlockRenderer {...params} node={wrapNode}>
        {params.node.data.content.map((child) => {
          return (
            <BlockRenderer key={child.id} {...params} node={child as Element} />
          );
        })}
      </BlockRenderer>
    );
  },
});
